import React, { useEffect, useState } from 'react';
import { Zap, Clock, Play } from 'lucide-react';
import api from '../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Slider } from './ui/slider';
import { Badge } from './ui/badge';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

export default function QuickStudyMode() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [maxDuration, setMaxDuration] = useState(30);
  const navigate = useNavigate();

  useEffect(() => {
    fetchItems();
  }, [maxDuration]);

  const fetchItems = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/quick-study?max_duration=${maxDuration}`);
      setItems(response.data.items || []);
    } catch (error) {
      console.error('Erro:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleStart = (item) => {
    navigate(`/topics/${item.id}`);
    toast.success(`Iniciando: ${item.title}`);
  };

  return (
    <Card className="shadow-md border-2 border-blue-200 dark:border-blue-800" data-testid="quick-study">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-lg text-slate-900 dark:text-slate-100">
          <Zap className="w-5 h-5 text-orange-500" />
          Estudo Rápido
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <p className="text-sm text-slate-600 dark:text-slate-400 mb-2">Tempo: {maxDuration} min</p>
          <Slider value={[maxDuration]} onValueChange={(v) => setMaxDuration(v[0])} min={5} max={60} step={5} />
        </div>

        {loading ? (
          <div className="text-center py-4 text-slate-500">Carregando...</div>
        ) : items.length === 0 ? (
          <p className="text-sm text-slate-500 text-center py-4">Nenhum conteúdo disponível.</p>
        ) : (
          <div className="space-y-2 max-h-48 overflow-y-auto">
            {items.map((item) => (
              <div key={item.id} className="flex items-center justify-between p-2 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800">
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-slate-900 dark:text-slate-100 truncate">{item.title}</p>
                  <div className="flex items-center gap-2 mt-1">
                    <Badge variant={item.type === 'review' ? 'destructive' : 'secondary'} className="text-xs">
                      {item.type === 'review' ? 'Revisão' : 'Novo'}
                    </Badge>
                    <span className="text-xs text-slate-500">{item.estimated_time}min</span>
                  </div>
                </div>
                <Button size="sm" onClick={() => handleStart(item)}><Play className="w-4 h-4" /></Button>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
